import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import CashModel from '../models/CashModel';
import CashAccountModel from '../models/CashAccountModel';

interface CashInputState {
    input: CashModel,
    selectedCashId: string,
    CashInputExpand: boolean,
    triggerFocusCompanyNameInput: number,
    triggerSave: number,
    triggerRefreshInput: number,
    accounts: CashAccountModel[],
    showCashDetail: boolean
}

const initialState: CashInputState = {
    input: {
        id: "",
        country: "",
        account: "",
        receipt: 0,
        payment: 0,
        description: "",
        updatedDate: ""
    } as unknown as CashModel,
    selectedCashId: "",
    CashInputExpand: true,
    triggerFocusCompanyNameInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0,
    accounts: [],
    showCashDetail: false
}

export const CashInputSlice = createSlice({
    name: "CashInput",
    initialState,
    reducers: {
        setCashInputId: (state, action: PayloadAction<string>) => {
            state.input.id = action.payload;
        },
        setCashInput: (state, action: PayloadAction<CashModel>) => {
            state.input = action.payload;
        },
        setDate: (state, action: PayloadAction<string>) => {
            state.input.updatedDate = action.payload;
        },
        setCountry: (state, action: PayloadAction<string>) => {
            state.input.country = action.payload;
        },
        setAccount: (state, action: PayloadAction<string>) => {
            state.input.account = action.payload;
        },
        setReceipt: (state, action: PayloadAction<number>) => {
            state.input.receipt = action.payload;
        },
        setPayment: (state, action: PayloadAction<number>) => {
            state.input.payment = action.payload;
        },
        setDescription: (state, action: PayloadAction<string>) => {
            state.input.description = action.payload;
        },
        setSelectedCashId: (state, action: PayloadAction<string>) => {
            state.selectedCashId = action.payload;
        },
        setCashInputExpand: (state, action: PayloadAction<boolean>) => {
            state.CashInputExpand = action.payload;
        },
        setTriggerFocusCompanyNameInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyNameInput = action.payload;
        },
        resetCashInput: (state) => {
            state.input = initialState.input;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
        setAccounts: (state, action: PayloadAction<CashAccountModel[]>) => {
            state.accounts = action.payload;
        },
        setShowCashDetail: (state, action: PayloadAction<boolean>) => {
            state.showCashDetail = action.payload;
        },
    }
});

export const CashInputSelector = createSelector(
    (state: RootState) => state.cashInput,
    (data) => data
);

export const {
    setCashInputId,
    setCashInput,
    setCountry,
    setDate,
    setAccount,
    setReceipt,
    setPayment,
    setDescription,
    setSelectedCashId,
    setCashInputExpand,
    setTriggerFocusCompanyNameInput,
    resetCashInput,
    setTriggerSave,
    setTriggerRefreshInput,
    setAccounts,
    setShowCashDetail
} = CashInputSlice.actions;

export default CashInputSlice.reducer;